import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=4830efea&scoped=true&"
import script from "./Curriculum.vue?vue&type=script&lang=ts&"
export * from "./Curriculum.vue?vue&type=script&lang=ts&"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=4830efea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830efea",
  null
  
)

export default component.exports